import { Alert, LinearProgress } from "@mui/material";
import { Status } from "../../enums/status";

export default function StatusDisplay({ status, message }: { status: Status; message: string }) {
  if (status === Status.ERROR) {
    return (
      <Alert variant="outlined" severity="error">
        {message}
      </Alert>
    );
  } else if (status === Status.SUCCESS) {
    return <Alert severity="success">{message}</Alert>;
  } else if (status === Status.LOADING) {
    return <LinearProgress />;
  }
  return <></>;
}
